import { Link } from 'react-router-dom';
import Header from '../../components/layout/header.component';
import Asaid from '../../components/layout/asaid.component';
import Footer from '../../components/layout/footer.component';
import useBgPages from '../../hooks/use-bg-pages.hook';
import { LandingRouteService } from '../../services/landing-route.service';

function ForbiddenPage() {
  useBgPages();
  const homeRoute = LandingRouteService.getHomeRoute();

  return (
    <div className="page d-flex flex-row flex-column-fluid">
      <Asaid />

      <div className="wrapper d-flex flex-column flex-row-fluid">
        <Header />

        <div className="content d-flex flex-column flex-column-fluid bg-cards-p">
          <div className="d-flex flex-column-fluid align-items-center justify-content-center px-5 py-10">
            <div className="container">
              <div className="row align-items-center justify-content-center g-10">
                <div className="col-12 col-lg-6 text-center text-lg-start">
                  <div className="mb-6">
                    <h1 className="text-info fw-bolder mb-3 fs-6x animated-Alert">403</h1>
                    <h1 className="fw-bolder mb-3 fs-3x inputb text-dark">No tienes permisos.</h1>

                    <p className="text-gray-600 fs-5 mb-8">
                      No tienes permisos habilitados para acceder a este módulo.
                      <br />
                      Si crees que se trata de un error, contacta al administrador.
                    </p>
                  </div>

                  <div className="d-flex flex-column flex-sm-row gap-4 justify-content-center justify-content-lg-start">
                    <Link to={homeRoute} className="btn btn-primary btn-lg px-8">
                      Regresar
                    </Link>
                  </div>
                </div>
                <div className="col-lg-6 d-none d-lg-flex justify-content-center">
                  <img
                    src="/assets/media/illustrations/undraw/no-access.svg"
                    alt="Acceso restringido"
                    className="img-fluid"
                    style={{ maxHeight: '380px' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default ForbiddenPage;
